/** Shared SVG icons for feature types (primitives + booleans). */
export const SHAPE_ICONS: Record<string, JSX.Element> = {
  box: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M3 5l5-3 5 3v6l-5 3-5-3V5z" />
      <path d="M3 5l5 3 5-3M8 8v6" />
    </svg>
  ),
  cylinder: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <ellipse cx="8" cy="4" rx="5" ry="2" />
      <path d="M3 4v8c0 1.1 2.24 2 5 2s5-.9 5-2V4" />
    </svg>
  ),
  sphere: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <circle cx="8" cy="8" r="5" />
      <ellipse cx="8" cy="8" rx="5" ry="2" />
    </svg>
  ),
  cut: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <circle cx="6" cy="11" r="2.5" />
      <circle cx="10" cy="11" r="2.5" />
      <path d="M7.5 9L12 3M8.5 9L4 3" />
    </svg>
  ),
  fuse: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <circle cx="6" cy="8" r="4" />
      <circle cx="10" cy="8" r="4" />
    </svg>
  ),
  intersect: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <circle cx="6" cy="8" r="4" strokeDasharray="2 1.5" />
      <circle cx="10" cy="8" r="4" strokeDasharray="2 1.5" />
      <path d="M8 5.1v5.8" strokeWidth="1.8" />
    </svg>
  ),
  fillet: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M4 3v7a4 4 0 004 4h5" />
      <path d="M4 3h2M13 14v-2" strokeDasharray="1.5 1.5" />
    </svg>
  ),
  chamfer: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M4 3v6l4 5h5" />
      <path d="M4 3h2M13 14v-2" strokeDasharray="1.5 1.5" />
    </svg>
  ),
  shell: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <rect x="3" y="3" width="10" height="10" rx="1" />
      <rect x="5" y="5" width="6" height="6" rx="0.5" strokeDasharray="1.5 1.5" />
    </svg>
  ),
  extrude: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <rect x="4" y="8" width="8" height="5" rx="0.5" />
      <path d="M4 8V5M12 8V5" strokeDasharray="1.5 1.5" />
      <path d="M4 5h8" />
      <path d="M8 3v-1M8 3l-2 1M8 3l2 1" strokeWidth="1" />
    </svg>
  ),
  importedPart: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <rect x="2" y="4" width="6" height="8" rx="0.5" />
      <rect x="8" y="2" width="6" height="8" rx="0.5" />
      <path d="M5 8h6" strokeDasharray="1.5 1" />
    </svg>
  ),
  sketch: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M3 12L6 4L10 8L13 3" />
      <circle cx="3" cy="12" r="1" fill="currentColor" />
      <circle cx="6" cy="4" r="1" fill="currentColor" />
      <circle cx="10" cy="8" r="1" fill="currentColor" />
      <circle cx="13" cy="3" r="1" fill="currentColor" />
    </svg>
  ),
  draft: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M4 13h8M5 13V5l6-2v10" />
      <path d="M5 5l6-2" strokeDasharray="1.5 1.5" />
    </svg>
  ),
  loft: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <rect x="3" y="2" width="10" height="4" rx="0.5" />
      <ellipse cx="8" cy="13" rx="4" ry="1.5" />
      <path d="M3 6c0 3 1 7 4 7M13 6c0 3-1 7-4 7" strokeDasharray="2 1.5" />
    </svg>
  ),
  revolve: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <ellipse cx="8" cy="10" rx="5" ry="2" />
      <path d="M8 3v10" strokeDasharray="1.5 1.5" />
      <path d="M11 5a4 4 0 010 6" />
    </svg>
  ),
  sweep: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M4 14c2-2 6-2 8 0M4 10c2-2 6-2 8 0M4 6c2-2 6-2 8 0M4 2c2-2 6-2 8 0" />
    </svg>
  ),
  mirror: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M8 2v12" strokeDasharray="2 1.5" />
      <path d="M3 5h3v6H3z" />
      <path d="M10 5h3v6h-3z" strokeDasharray="1.5 1.5" />
    </svg>
  ),
  linearPattern: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <rect x="1" y="5" width="3" height="6" rx="0.5" />
      <rect x="6" y="5" width="3" height="6" rx="0.5" />
      <rect x="11" y="5" width="3" height="6" rx="0.5" />
      <path d="M4.5 3h7" />
      <path d="M10 2l1.5 1-1.5 1" />
    </svg>
  ),
  circularPattern: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
      <circle cx="8" cy="8" r="5" strokeDasharray="2 1.5" />
      <rect x="6.5" y="2" width="3" height="2" rx="0.5" />
      <rect x="11" y="6.5" width="3" height="2" rx="0.5" />
      <rect x="6.5" y="12" width="3" height="2" rx="0.5" />
      <rect x="2" y="6.5" width="3" height="2" rx="0.5" />
    </svg>
  ),
};
